module.exports = {"termOfUse":"Wyrażam zgodę na przetwarzanie przez ELITA moich danych osobowych w celu przeprowadzenia procesu związanego z złożeniem i obsługą zgłoszenia, utworzonego w aplikacji internetowej. *","backButtonLabel":"Wróć","issueComplaintButtonLabel":"Założ zgłoszenie"}


//////////////////
// WEBPACK FOOTER
// ./src/components/IssueComplaint/translate.json
// module id = 1234
// module chunks = 0